export const downloadsData = {
  title: "Ke stažení",
};